var BASWebServices;
(function (BASWebServices) {
    var MainController = (function () {
        function MainController($scope, $rootScope, $timeout, ngProgressFactory, $interval, $http, $location, $window, cmdiOptions, cfgService, ngDialog, hs, faqs, touService, maintenanceService, highLoadService, serviceListService, versionService, $cookies) {
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$timeout = $timeout;
            this.ngProgressFactory = ngProgressFactory;
            this.$interval = $interval;
            this.$http = $http;
            this.$location = $location;
            this.$window = $window;
            this.cmdiOptions = cmdiOptions;
            this.cfgService = cfgService;
            this.ngDialog = ngDialog;
            this.hs = hs;
            this.faqs = faqs;
            this.touService = touService;
            this.maintenanceService = maintenanceService;
            this.highLoadService = highLoadService;
            this.serviceListService = serviceListService;
            this.versionService = versionService;
            this.containerClass = "";
            this.showServicesSidebar = false;
            this.favoritesPresent = true;
            this.showNavBar = function () {
                return this.cfgService.showNavBar;
            };
            var _this = this;
            var _scope = $scope;
            $scope.mc = this;
            this.containerClass = "services";
            $rootScope.cookies = $cookies;
            if ($location.protocol() === "http"
                && !($window.location.href.lastIndexOf("127.0.0.1") != -1)
                && !($window.location.href.lastIndexOf("localhost") != -1)) {
                console.log("Redirect to https (" + $window.location.href + ")");
                $window.location.href = $location.absUrl().replace('http', 'https');
            }
            if ($location.host().lastIndexOf("webapp.phonetik.uni") != -1
                && $location.host().lastIndexOf("webapp3.phonetik.uni") != -1) {
                console.log("Redirecting to clarin.phonetik[...] (" + $window.location.href + ")");
                $window.location.href = $location.absUrl().replace('webapp.phonetik.uni', 'clarin.phonetik.uni').replace('webapp3.phonetik.uni', 'clarin.phonetik.uni');
            }
            this.$rootScope.$on("dimming_screen_on", function () {
                _this.$rootScope.$broadcast("prevent_window_from_being_closed_ACTIVATE");
            });
            this.$rootScope.$on("prevent_window_from_being_closed_ACTIVATE", function () {
                window.onbeforeunload = function (e) {
                    e = e || window.event;
                    if (e) {
                        e.returnValue = 'Sure?';
                    }
                    return 'Sure?';
                };
            });
            this.$rootScope.$on("prevent_window_from_being_closed_DEACTIVATE", function () {
                window.onbeforeunload = null;
            });
            this.$rootScope.$on("dimming_screen_off", function () {
                _this.$rootScope.$broadcast("prevent_window_from_being_closed_DEACTIVATE");
            });
            this.$rootScope.ngProgressBar = this.ngProgressFactory.createInstance();
            this.$rootScope.ngProgressBar.setColor("rgb(166,185,204)");
            this.$rootScope.ngProgressBar.setHeight("15px");
            this.maintenanceService;
            this.$timeout(function () {
                _scope.maintenanceMessage = _this.maintenanceService.getMaintenanceMessage();
                if (_scope.maintenanceMessage != "") {
                    _this.ngDialog.open({
                        template: 'views/partials/dialogs/maintenance.html',
                        className: 'ngdialog-theme-default',
                        closeByEscape: true,
                        scope: _scope
                    });
                }
            }, 2000);
            this.$timeout(function () {
                _scope.highLoadMessage = _this.highLoadService.getHighLoadMessage();
                if (_scope.highLoadMessage != "") {
                    _this.ngDialog.open({
                        template: 'views/partials/dialogs/highLoad.html',
                        className: 'ngdialog-theme-default',
                        closeByEscape: true,
                        scope: _scope
                    });
                }
            }, 2000);
            this.$timeout(function () {
                var consentSetting = JSON.parse(localStorage.getItem("basWebServices.consentToClarinStats"));
                if (consentSetting !== true) {
                    _this.ngDialog.open({
                        template: 'views/partials/dialogs/consentToStats.html',
                        className: 'ngdialog-theme-default',
                        closeByEscape: false,
                        showClose: false,
                        closeByDocument: false,
                        scope: _scope,
                        controller: ['$scope', '$window', function ($scope, $window) {
                                $scope.setConsent = function () {
                                    localStorage.setItem("basWebServices.consentToClarinStats", JSON.stringify(true));
                                    $window.loadMatomo();
                                    $scope.closeThisDialog();
                                };
                            }]
                    });
                }
            }, 2000);
            var setLoadFunction = function () {
                var link = BASWebServices.ConfigService.GET_BAS_GET_LOAD_INDICATOR();
                _this.$http.get(link, {
                    _this: _this
                })
                    .then(function (response) {
                    var status = response.status;
                    var headers = response.headers;
                    var config = response.config;
                    var content = response.data;
                    var parser = new DOMParser();
                    var xmlDocument = parser.parseFromString(content, "text/xml");
                    var load = xmlDocument.querySelector("LoadIndicator").innerHTML;
                    config._this.$rootScope.serverLoad = load;
                })
                    .catch(function (response) {
                    var data = response.data;
                    var headers = response.headers;
                    var config = response.config;
                    console.error("Could not get load indicator!");
                    config._this.$rootScope.serverLoad = -1;
                });
            };
            setLoadFunction();
            this.$interval(setLoadFunction, BASWebServices.ConfigService.GET_CHECK_LOAD_INTERVAL());
            this.hs;
            this.faqs.getFAQContent();
            touService.getTOUContentAcademic();
            touService.getTOUContentCommercial();
            versionService.getVersionPromise("services").then(function successCallback(response) {
                _scope.webservicesVersion = response.data.trim();
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            this.getServices();
            this.showServicesSidebar = JSON.parse(window.localStorage.getItem('basWebServices.showServicesSidebar'));
        }
        MainController.prototype.getServices = function () {
            this.services = this.serviceListService.getServices();
            this.favoritesPresent = this.services.filter(function (x) { return x.favorite; }).length > 0;
        };
        MainController.prototype.isCurrentPage = function (page) {
            var currentRoute = this.$location.path().substring(1);
            var transformedPage = page.replaceAll(".", "/");
            if (currentRoute === transformedPage ||
                (currentRoute.startsWith(transformedPage + "/") && transformedPage !== "interface")) {
                return true;
            }
            else {
                return false;
            }
        };
        ;
        MainController.prototype.toggleServicesSidebar = function () {
            this.showServicesSidebar = !this.showServicesSidebar;
            window.localStorage.setItem('basWebServices.showServicesSidebar', JSON.stringify(this.showServicesSidebar));
        };
        MainController.prototype.setFavorite = function (event, serviceName, makeFavorite) {
            this.serviceListService.setFavorite(serviceName, makeFavorite);
            this.getServices();
            event.stopPropagation();
            event.preventDefault();
        };
        return MainController;
    }());
    BASWebServices.MainController = MainController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=MainController.js.map